module.exports = __webpack_public_path__ + "img/c02_buildingtouchofra_Normal_ua.2f3b8eb2.webp";